var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"job-list"},[_c('data-table',{ref:"table",attrs:{"service":_vm.LogService,"entity":_vm.entity,"columns":_vm.columns,"filters":_vm.logFilters,"go-to-details-on-row-click":false},scopedSlots:_vm._u([{key:"type",fn:function(ref){
var row = ref.row;
return [_c(_vm.typeMappings[row.type],{tag:"component"})]}},{key:"level",fn:function(ref){
var row = ref.row;
return [_c('status-badge',{attrs:{"status":row.level}})]}},{key:"created_at",fn:function(ref){
var row = ref.row;
return [_vm._v("\n      "+_vm._s(_vm.$formatDate(row.created_at, _vm.FRIENDLY_DATE_FORMAT))+"\n    ")]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }